<template>
    <window-portal :open="data.show" @close="data.show = false">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center>
                <div>
                    <p style="font-size: 30px;">Vista previa de impresión de Comprobante de Liquidación</p>
                </div>
            </center>
            <br />
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="sendMail()">
                    Enviar Correo
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="downLoadJSON()">
                    Descargar JSON
                </button>
            </center>
             <!-- {{ JSON.stringify(data) }}  -->
            <center>
                <div v-if="loading">
                    <p>Cargando...</p>
                </div>
            </center>
        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>

        <div class="book"
            style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">

            <!--Configuración de la pagina-->
            <div class="page" ref="dataprint"
                style="position: relative; width: 1000px; min-height: 1294px; margin: 0 auto;">

                <div
                    v-for="(page, indexPage) in pages"
                    :key="indexPage"
                    style="
                        position: relative;
                        width: 1000px;
                        min-height: 1294px;
                        background: white;
                        margin: 0 auto;
                        margin-bottom: 20px;
                    "
                >
                    <!-- Configuración del contenido de la pagina -->
                    <div class="subpage" style="height: 1230px; padding-top: 20px; overflow: hidden;">
                        <div style="margin-left: 80px; margin-right: 50px;">
                            <div style="width: 100%;">
                                <table style="font-size: 12px; border-collapse: collapse; width: 100% !important;">
                                    <tr style="">
                                        <td colspan="5" style="text-align: center;"><h2>DOCUMENTO TRIBUTARIO ELECTRÓNICO</h2></td>
                                    </tr>
                                    <tr style="">
                                        <td colspan="5" style="text-align: center;"><h1>COMPROBANTE DE LIQUIDACIÓN</h1></td>
                                    </tr>
                                    <tr>
                                        <td colspan="5">
                                            <hr />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            <b>Código Generación:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            {{ data.data.IdentificacionCodigoGeneracion }} 
                                        </td>

                                        <td rowspan="3" style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            <img ref="qrcode"/>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            <b>Modelo de facturación:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            {{ data.data.IdentificacionTipoModelo == 1 ? "Previo" : "" }}
                                            {{ data.data.IdentificacionTipoModelo == 2 ? "Diferido" : "" }}
                                        </td>

                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            <b>Número de Control:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            {{ data.data.IdentificacionNumeroControl }}
                                        </td>

                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            <b>Tipo de Transmisión:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            {{ data.data.IdentificacionTipoOperacion ? 'NORMAL' : 'CONTINGENCIA' }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            <b>Sello de recepción:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            {{ data.data.SelloRecibido }}
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            <b>Fecha y hora de generación:</b>
                                        </td>
                                        <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 20%;">
                                            {{ `${data.data.IdentificacionFecEmi} ${data.data.IdentificacionHorEmi}` }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div style="width: 100%;">
                                <table style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                    <div style="border-collapse: collapse; border: 1px solid black;">
                                        <tr>
                                            <td colspan="2" style="text-align: center;"><h2>COMISIONISTA (Emisor)</h2></td>
                                            <td colspan="2" style="text-align: center;"><h2>MANDANTE (Receptor)</h2></td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Nombre o Razón Social:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                                {{ data.data.EmisorNombre }}
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Nombre o Razón Social:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                                {{ data.data.ReceptorNombre }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Nombre comercial:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.EmisorNombreComercial }}
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>NIT:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ applyNitMaskHandlingHomologationOutOfInput(data.data.EmisorNit) }}
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>NIT:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ applyNitMaskHandlingHomologationOutOfInput(data.data.ReceptorNit) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>NRC:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                                {{ applyDUIMaskOutOfInput(data.data.EmisorNrc) }}
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>NRC:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                                {{ applyDUIMaskOutOfInput(data.data.ReceptorNrc) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Actividad Económica:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.EmisorDescActividad }}
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Actividad Económica:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.ReceptorDescActividad }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Dirección:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.EmisorDireccionComplemento }}
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Dirección:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.ReceptorDireccionComplemento }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Número de Teléfono:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667;">
                                                {{ data.data.EmisorTelefono }}
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Nombre Comercial:</b>
                                            </td>
                                            <td colspan="3" style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.ReceptorNombreComercial }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Correo Electrónico:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.EmisorCorreo }}
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Correo Electrónico:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.ReceptorCorreo }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Tipo de Establecimiento:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.EmisorTipoEstablecimiento === "01" ? "Sucursal Agencia" : "" }}
                                                {{ data.data.EmisorTipoEstablecimiento === "02" ? "Casa Matriz" : "" }}
                                                {{ data.data.EmisorTipoEstablecimiento === "04" ? "Bodega" : "" }}
                                                {{ data.data.EmisorTipoEstablecimiento === "07" ? "Predio y/o patio" : "" }}
                                                {{ data.data.EmisorTipoEstablecimiento === "20" ? "Otro" : "" }}
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </div>
                                </table>
                                <table
                                    style="width: 100% !important; font-size: 11px; margin-top: 40px; border-collapse: collapse;" border="1">
                                    <tr>
                                        <td style="padding: 5px;"><b>N.</b></td>
                                        <td style="padding: 5px; width: 60px;"><b>Tipo de Doc. Relacionado</b></td>
                                        <td style="padding: 5px;"><b>N. Doc. Relacionado</b></td>
                                        <td style="padding: 5px; width: 60px;"><b>Fecha</b></td>
                                        <td style="padding: 5px;"><b>Observación por ítem</b></td>
                                        <td style="padding: 5px; width: 65px;"><b>Exportaciones</b></td>
                                        <td style="padding: 5px; width: 65px;"><b>Ventas No Sujetas</b></td>
                                        <td style="padding: 5px; width: 65px;"><b>Ventas Exentas</b></td>
                                        <td style="padding: 5px; width: 65px;"><b>Ventas Gravadas</b></td>
                                    </tr>

                                    <tr v-for="(item, index) in valuesRows[indexPage]" :key="index">
                                        <td style="padding: 5px;">{{ index  + 1 }}</td>
                                        <td style="padding: 5px;">{{ item.DTE_Type }}</td>
                                        <td style="padding: 5px;">{{ item.CodigoGeneracion }}</td>
                                        <td style="padding: 5px;">{{ item.InvoiceDateDF }}</td>
                                        <td style="padding: 5px;">{{ item.InvoiceInternalNote || '' }}</td>
                                        <td style="padding: 5px;">$ 0</td>
                                        <td style="padding: 5px;">$ {{ item.InvoiceTotalNoSuj }}</td>
                                        <td style="padding: 5px;">$ {{ item.InvoiceTotalExenta }}</td>
                                        <td style="padding: 5px;">$ {{ item.InvoiceTotalGravada }}</td>
                                    </tr>
                                </table>

                                <table
                                    v-if="indexPage == valuesRows.length - 1"
                                    style="width: 100% !important; font-size: 11px; border-collapse: collapse;" border="1"> 
                                    <!-- <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Suma Total Operaciones:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ data.data.ResumenClSubTotalVentas }}</td>
                                    </tr> -->
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Total Gravadas:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ data.data.ResumenClTotalGravada }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Total NoSuj:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ data.data.ResumenClTotalNoSuj }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Total Exenta:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ data.data.ResumenClTotalExenta }}</td>
                                    </tr>
                                    <tr v-for="(value, index) in JSON.parse(data.data.ResumenClTributos)" :key="index">
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>{{ value.descripcion }}:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ value.valor }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Monto Total de la Operación:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ data.data.ResumenClMontoTotalOperacion }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>IVA Percibido:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ data.data.ResumenClIvaPerci }}</td>
                                    </tr>
                                   
                                    <tr>
                                        <td colspan="5" style="border: none; width: 547px;"></td>
                                        <td colspan="3" style="padding: 5px;"><b>Total:</b></td>
                                        <td style="padding: 5px; width: 141px;">$ {{ data.data.ResumenClTotal }}</td>
                                    </tr>
                                </table>

                                <table
                                    v-if="indexPage == valuesRows.length - 1"
                                    style="width: 100% !important; font-size: 11px; margin-top: 20px;">

                                    <div style="border-collapse: collapse; border: 1px solid black;">
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;"><b>Valor en Letras:</b></td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">{{ data.data.ResumenClTotalLetras }}</td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;"><b>Condición de la Operación:</b></td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.ResumenClCondicionOperacion == 1 ? "Contado" : "" }}
                                                {{ data.data.ResumenClCondicionOperacion == 2 ? "A Crédito" : "" }}
                                                {{ data.data.ResumenClCondicionOperacion == 3 ? "Otro" : "" }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;"></td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;"></td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;"></td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;"></td>
                                        </tr>
                                    </div>
                                </table>

                                <table
                                    v-if="indexPage == valuesRows.length - 1"
                                    style="width: 100% !important; font-size: 11px; margin-top: 20px;">

                                    <div style="border-collapse: collapse; border: 1px solid black;">
                                        <tr>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Responsable por parte del emisor:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.ExtensionNombEntrega }}
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                <b>Documento del responsable:</b>
                                            </td>
                                            <td style="padding-left: 10px; padding-right: 10px; padding-bottom: 5px; width: 16.66666666666667%;">
                                                {{ data.data.ExtensionDocuEntrega }}
                                            </td>
                                        </tr>
                                    </div>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-html="footer" style="width: 100% !important;"></div>
            </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
import QRCode from 'qrcode';
//import html2canvas from "html2canvas"
import {numberToText} from '@/helpers/conveterNumberText.js'
import {
    applyDUIMaskOutOfInput,
    applyNitMaskHandlingHomologationOutOfInput
} from "../../helpers/masks"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"
export default {
    name: "PrintLiquidacionesCl",
    props: ['data'],
    components: { WindowPortal },
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            mailLabel: null,
            numPages: 0,
            valuesRows: [],
        }
    },
    watch: {
        'data.show'(){
            this.$nextTick(async () => {

                if(this.data.show){
                    await this.calculatePagesOfDoc()
                    const { IdentificacionAmbiente, IdentificacionCodigoGeneracion, IdentificacionFecEmi } = this.data.data;
    
                    const url = `https://admin.factura.gob.sv/consultaPublica?ambiente=${IdentificacionAmbiente}&codGen=${IdentificacionCodigoGeneracion}&fechaEmi=${IdentificacionFecEmi}`;
    
                    const opt = {
                        errorCorrectionLevel: 'H',
                        type: 'image/png',
                        quality: 0.3,
                        margin: 1,
                        color: {
                            dark:"#000000",
                            light:"#ffffff"
                        },
                        width: 100
                    }
    
                    QRCode.toDataURL(url, opt, ( error, url ) => {
                        if(error){
                            console.log('Error al generar código qr: ' + error.message);
                            throw error;
                        }
    
                        console.log();
                        this.$refs.qrcode.src = url;
                    })
                }
            })
        }
    },
    mounted() {
        //console.log(this.data);
    },
    computed: {
        pages() {
            // Generar un arreglo con `numPages` elementos
            return Array.from({ length: this.numPages });
        },
    },
    methods: {
        calculatePagesOfDoc() {
            const invoices = Array.isArray(this.data?.invoices) ? this.data.invoices : []
            const rowsPerRegularPage = 18
            const rowsOnLastPage = 10

            this.valuesRows = []

            try {
                if (!invoices.length) {
                    this.valuesRows = [[]]
                    this.numPages = 1
                    return
                }

                if (invoices.length <= rowsOnLastPage) {
                    this.valuesRows = [invoices]
                    this.numPages = 1
                    return
                }

                const fullRegularPages = Math.floor(invoices.length / rowsPerRegularPage)
                const remainingRows = invoices.length % rowsPerRegularPage
                let cursor = 0

                for (let pageIndex = 0; pageIndex < fullRegularPages; pageIndex++) {
                    this.valuesRows.push(invoices.slice(cursor, cursor + rowsPerRegularPage))
                    cursor += rowsPerRegularPage
                }

                if (remainingRows === 0) {
                    this.valuesRows.push([])
                } else if (remainingRows <= rowsOnLastPage) {
                    this.valuesRows.push(invoices.slice(cursor))
                } else {
                    this.valuesRows.push(invoices.slice(cursor))
                    this.valuesRows.push([])
                }

                this.numPages = this.valuesRows.length
            }
            catch(err) {
                alert(err)
            }
        },
        GetnumberToText(number) {
            if(number) return numberToText(number)
            else return ''
        },
        applyDUIMaskOutOfInput(value){
            return applyDUIMaskOutOfInput(value);
        },
        applyNitMaskHandlingHomologationOutOfInput(value){
            return applyNitMaskHandlingHomologationOutOfInput(value);
        },

        async Print(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            
            
            //doc.deletePage(this.numPages)

            doc.autoPrint({variant: 'non-conform'});
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },
        async downLoadJSON() {
            try {
                const aElement = document.createElement('a');
                aElement.setAttribute('download', this.data.data.ID_Invoice+ "_"+this.data.data.IdentificacionFecEmi.replaceAll("/","-") + "_"+this.data.data.ReceptorNombreComercial.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".json");
                const blob = new Blob([JSON.stringify(this.data.data.JsonMh)], { type: 'application/json' });
                const href = URL.createObjectURL(blob);
                aElement.href = href;
                aElement.click();
                URL.revokeObjectURL(href);
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al descargar JSON';
                console.log(error);
            }
        },
        async sendMail() {
            try {
                this.loadin = true
                this.mailLabel = null;
                this.mailLabel = 'Enviando...';
                var doc = new jsPDF('p', 'pt', 'letter')
                await doc.html(this.$refs.dataprint, {
                    callback: function(doc){
                        doc.output()
                    },
                    x: 0,
                    y: 0,
                    margin: [0, 0, 0, 0],
                    html2canvas:{ 
                        scale: 0.612,
                        useCORS: true,
                        logging: false,
                        allowTaint: true
                    },
                });

                const jsonMH = this.data.data.JsonMh.dteJson
                const ID_Invoice = this.data.data.ID_Invoice;

                const body = {
                    dtefilebuffer: new Buffer.from(doc.output('arraybuffer')),
                    dtejson: { ...jsonMH, ID_Invoice },
                    dtefilebufferfilename: this.data.data.ID_Invoice+ "_"+this.data.data.IdentificacionFecEmi.replaceAll("/","-") + "_"+this.data.data.ReceptorNombreComercial.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')
                };

                await this.$API.invoices.sendInvoiceMail(body);

                this.mailLabel = 'Se envió el correo correctamente';
                this.$emit('mailSent');
            } catch (error) {
                this.mailLabel = `Ocurrió el siguiente error al enviar el correo ${ error }`;
            } finally {
                this.loading = false
            }
        },
        async Download(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            //doc.deletePage(2)
            doc.save(this.data.data.ID_Invoice+ "_"+this.data.data.IdentificacionFecEmi.replaceAll("/","-") + ".pdf"); //Agregado por Juan 13082023

            this.loading = false
        },
    }
}
</script>

<style scoped>
.u-row .u-col-100 {
    width: 100% !important;
}

.btnclean {
    border-radius: 15px;
    border: 1px solid white;
    background-color: #F29D35 !important;
    color: white !important;
}

.btnclose {
    border-radius: 15px;
    border: 1px solid white;
    background-color: rgb(255, 38, 38) !important;
    color: white !important;

}

* {
    font-family: Arial, Helvetica, sans-serif !important;
}</style>
